import { Map } from 'immutable';

export default Map({
  loading: false,
  data: [],
  used: [],
  error: null,
});
